import {Button, ButtonGroup, Spinner} from 'react-bootstrap'
import {useDisclourse} from '../../hooks/useDisclourse'
import {useEffect, useState} from 'react'
import {useQuery} from '@apollo/client'
import {toast} from 'react-toastify'
import {ModalAddUserDeductionType} from './components/ModalAddUserDeductionType'
import {IAllCommisionDeductionTypesNode, IResAllCommisionDeductionTypes} from '../../types/users'
import {GET_ALL_USER_DEDUCTIONS_TYPE} from '../../gql/queries/userDeductionTypesQuery'
import { ModalDeleteDeductionType } from './components/ModalDeleteDeductionType'

export const UserDeductionTypePage = () => {
  const {data, loading, error, refetch} = useQuery<IResAllCommisionDeductionTypes>(
    GET_ALL_USER_DEDUCTIONS_TYPE,
    {
      fetchPolicy: 'no-cache',
    }
  )
  const [info, setInfo] = useState<IAllCommisionDeductionTypesNode | null>(null)
  const {isOpen: isOpenAdd, onClose: onCloseAdd, onOpen: onOpenAdd} = useDisclourse()
  const {isOpen: isOpenDelete, onClose: onCloseDelete, onOpen: onOpenDelete} = useDisclourse()
  const {isOpen: isOpenEdit, onClose: onCloseEdit, onOpen: onOpenEdit} = useDisclourse()

  useEffect(() => {
    if (error) {
      toast.error('Error: ' + error.message)
    }
  }, [error])

  if (!data || loading) {
    return (
      <div>
        <div className='d-flex align-items-center justify-content-between'>
          <h2>User Deduction Types</h2>
          <Button
            variant='primary'
            size='sm'
            onClick={() => {
              onOpenAdd()
            }}
          >
            <i className='bi bi-plus' />
            Add Deduction Type
          </Button>
        </div>
        <div className='d-flex align-items-center justify-content-center' style={{height: '40vh'}}>
          <Spinner animation='border' />
        </div>
      </div>
    )
  }

  return (
    <>
      <div>
        <div className='d-flex align-items-center justify-content-between'>
          <h2>User Deduction Types</h2>
          <Button
            variant='primary'
            size='sm'
            onClick={() => {
              onOpenAdd()
            }}
          >
            <i className='bi bi-plus' />
            Add Deduction Type
          </Button>
        </div>
        <div>
          <table className='table gs-7 gy-7 gx-7'>
            <thead>
              <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                <th>Name</th>
                <th>Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {!data && loading && <Spinner animation='border' />}
              {data.allCommissionDeductionType.edges.map(({node}) => (
                <tr key={node.id}>
                  <td>{node.name}</td>
                  <td>
                    <span>{node.deductionType}</span>
                  </td>
                  <td className='text-center'>
                    <ButtonGroup className='btn-sm'>
                      <Button
                        size='sm'
                        variant='secondary'
                        className='btn-sm btn-edit'
                        onClick={() => {
                          setInfo(node)
                          onOpenEdit()
                        }}
                      >
                        <i className='bi bi-pencil fs-4' />
                      </Button>
                      <Button
                        size='sm'
                        variant='danger'
                        className='btn-sm btn-delete'
                        onClick={() => {
                          setInfo(node)
                          onOpenDelete()
                        }}
                      >
                        <i className='bi bi-trash  fs-4'></i>
                      </Button>
                    </ButtonGroup>
                  </td>
                </tr>
              ))}
              {data.allCommissionDeductionType.edges.length === 0 && (
                <tr>
                  <td colSpan={3} className='text-center'>
                    There are no Deductions
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {isOpenAdd && (
        <ModalAddUserDeductionType
          keyboard={false}
          backdrop='static'
          isOpen={isOpenAdd}
          isEdit={false}
          onClose={onCloseAdd}
          refetch={refetch}
        />
      )}
      {isOpenEdit && info && (
        <ModalAddUserDeductionType
          keyboard={false}
          backdrop='static'
          commisionDeductionType={info}
          isOpen={isOpenEdit}
          onClose={onCloseEdit}
          isEdit={true}
          refetch={refetch}
        />
      )}
      {isOpenDelete && info && (
        <ModalDeleteDeductionType
          infoEdit={info}
          isOpen={isOpenDelete}
          onClose={onCloseDelete}
          refetch={refetch}
        />
      )}
    </>
  )
}
